<template>
<div class="map-container">
  <div class="unit-change-container" v-show="routeRendered && isMyRaces" v-on:click="toggleUnit();renderDistanceMarkers()">
    <img :src="unitSwitchImage">
  </div>
  <div id="map"></div>
  <router-view></router-view>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.js'
import mapboxgl from 'mapbox-gl'
import polyline from '@mapbox/polyline';
import VueTruncate from 'vue-truncate-filter'
import BottomNav from './BottomNav'
import _ from 'lodash'
import { userRef } from '../firebase'
import firebase from 'firebase'
import { mapGetters } from 'vuex'
import { store } from '../store/store'
import { mapFields } from 'vuex-map-fields'
import moment from 'moment'
import { popupVue } from '../helpers/popUp'
import { raceHasPath } from '../helpers/utils'
import 'mapbox-gl/dist/mapbox-gl.css'
import MapManager from '../helpers/mapManager'

Vue.use(VueTruncate)

mapboxgl.accessToken = 'pk.eyJ1IjoibWlra29hdGEiLCJhIjoiY2l5Y3V5czBjMDA4ZzJ3cXBibXZhaDkzciJ9.F-rRrrNLnB0MfKtcosgmxA';

const mapInteractionHandlers = [
  'scrollZoom', 'dragPan', 'touchZoomRotate', 'dragRotate', 'keyboard', 'boxZoom', 'doubleClickZoom'
]

popupVue.$mount()

var popup

export default {
  name: 'main',
  data() {
    return {
      kmSwitch: require('../img/km_switch.svg'),
      miSwitch: require('../img/mi_switch.svg'),
      pepVoiceMsgs: {}
    }
  },
  computed: {
    ...mapGetters(['race', 'selectedPepPointId', 'myRacesMessages', 'isOwnPep']),
    ...mapFields(['routeRendered', 'markers', 'isMyRaces', 'isEvent', 'isEventEdit', 'isMetric']),
    isRaceEnded() {
      try {
        const end = moment(this.race.data.event.end * 1000)
        const now = moment()
        return now.isAfter(end)
      } catch (err) {
        return false
      }
    },
    unitSwitchImage() {
      return this.isMetric ? this.kmSwitch : this.miSwitch
    },
  },
  mounted() {
    console.log("mounted")
    this.$router.replace('login')
    MapManager.renderMap()
  },
  watch: {
    //Normi reitti loaded
    'race.geojson': {
      handler: function(newItem) {
        if (this.race) {
          if(this.routeRendered === false) {
            MapManager.renderPath()
          }
          this.$store.dispatch('initInformation')
        }
      },
      //deep:true
    },
    //MyRaces reitti loaded
    'race.data': {
      handler: function(newItem) {
        if (this.race && raceHasPath()) {
          if(this.routeRendered === false) { //todo fixthis
            MapManager.renderPath()
            popupVue.setupMessages(this.race.data.racePepPoints)
          }
        }
      },
      //deep:true
    },
    race: {
      handler: function(newItem) {
        if (this.race) {
          console.log(this.race)
        } else {
          MapManager.clearMap()
        }
      }
    },
    //Render markers according to the state of the race
    isRaceEnded: {
      handler: function(newValue, oldValue) {
        console.log("IsRaceEnded watcher isMyRaces = " + this.isMyRaces)
        if(oldValue == false && newValue == true) {
          if (this.isMyRaces) {
            MapManager.clearMarkers()
            let pepPoints = this.race.data.racePepPoints
            MapManager.renderMarkers()
          }
        }
      }
    },
    $route: {
      handler: function(to, from) {
        if ((to.name === 'MapView' && from.name !== 'PepPoint') || (to.name === 'MyRacesInformation' && from.name === 'NewRace')) {
          console.log('ENABLOIDAAN INTERAKTIO')
          MapManager.enableInteraction()
        } else if ((from.name === 'MapView' && to.name !== 'PepPoint') || (from.name === 'MyRacesInformation' && to.name === 'MyRaces') || (from.name === 'NewRace')) {
          MapManager.disableInteraction()
          popupVue.cancel()
        }

        if (from.name === 'NewRace' && to.name !== 'Information' && to.name !== 'MyRacesInformation') {
          console.log("Leaving newrace, clearing map")
          MapManager.clearIfRoute()
        }

        if ((to.name === 'MyRaces' && from.name === 'MyRacesInformation') || (to.name === 'NewRace' && from.name === 'Information') || (to.name === 'MyRaces' && from.name === 'Done') ) {
          this.emptyRace()
        }
      }
    }
  },
  components: {
    BottomNav,
  },
  methods: {
    toggleUnit() {
      this.isMetric = !this.isMetric
    },
    emptyRace() {
      console.log("emptyRace()")
      this.$store.dispatch('unbindRaceRef').then(() => {
        console.log("unbinded", this.race)
        this.$store.commit('emptyRace')
      })
    },
    renderDistanceMarkers() {
      MapManager.renderDistanceMarkers()
    },
  },
}
</script>



<style lang="scss">
@import '../styles/styles.scss';

.marker {
    width: 40px;
    height: 40px;
    margin-top: -18px;
    margin-left: 7px;
    cursor: pointer;
}

.marker.runner {
    background-image: url("../img/pep_user.svg");
}

.marker.runner-editable {
    background-image: url("../img/pep_user_editable.svg");
}

.marker.friendBefore {
    background-image: url("../img/racepep_gray.svg");
}

.marker.friendAfter {
    background-image: url("../img/racepep_black.svg");
}

.marker.selected {
    background-image: url("../img/racepep_green.svg");
}

.marker.waypoint {
    background-image: url("../img/plotter/waypoint.svg");
    height: 18px;
    width: 18px;
    margin: 0;
}


.myRaces-popup {

    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;

    .top-row {
      display: flex;
      width: 100%;
      justify-content: space-between;
      flex-direction: row;
      text-align: center;

      .sender-container {
        flex: 1;
        label {
          margin-left: 20px;
        }
      }

      img {
    		width: 20px;
    		height: 20px;
    		margin: 0px;
    		cursor: pointer;
    	}
    }



    .myRaces-sender {
        font-size: 15px;
        font-weight: 700;
    }

    .popup-content {

        //height: 100px;
        //width: 220px;
        width: auto;
        height: auto;

        .popup-audio-content {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction:column;
            height: 80px;
            width: 120px;

            img {
              cursor: pointer;
            	width: 30px;
            	height: 30px;
            	display: flex;
            	align-self: center;
            }

        }

        .popup-message-content {

            textarea {
                font-size: 14px;
                resize: none;
                padding: 0;
                margin-top: 5px;
                padding: 5px;
                height: 100px;
                width: 220px;
                color: black;
            }
        }

    }

}

.mapboxgl-popup-close-button {
    padding: 8px;
}
</style>

<style lang="scss" scoped>
@import '../styles/styles.scss';

#map {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
}

.unit-change-container {
  width: 50px;
  height: 50px;
  top: 1em;
  right: 3em;
  border-radius: 50px;
  background-color: $white;
	z-index: 1;
	position: fixed;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	display: flex;
	cursor: pointer;

  img {
    height: 100%;
  }
}

@media screen and (min-width: 1140px) {
  .unit-change-container {
    top: 2.7em;
    right: 3.2em;
  }
}
</style>
